// extracted by mini-css-extract-plugin
module.exports = {"main":"styles-module--main--Ekhk0"};